<template>
    <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','padding-bottom':'50px'}" id="outermost">
      <van-nav-bar
            title="我的项目"
            id="topbar"
        />
      <div style="padding:20px">

        <div v-if="proList.length>0">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <van-cell v-for="(item,i) in proList" :key="i" class="parentPro">
              <van-row class="parentProName" type="flex" justify="space-between" align="center">
                  <van-col class="proName" span="17">{{item.completeName}}</van-col>
                  <van-col v-if="item.children.length>0" class="proStatus" span="7" style="text-align:right">{{item.proStatus}}</van-col>
                  <van-col v-else class="proStatus" span="7" style="text-align:right">未添加任务</van-col>
              </van-row>

              <!--子项目-->
              <div style="width:100%;display: flex;flex-flow:row wrap;justify-content: space-between;padding-bottom:10px;">
                <div v-for="(child,ind) in item.children" :key="ind" style="width:48%;margin-top:10px;" @click="toCompanyList(child.id,child.completeName)">
                  <div v-if="ind%2==0" class="childItem">
                    <div class="proName">{{child.name}}</div>
                    <van-row type="flex" justify="space-between" align="center">
                        <van-col class="proStatus">{{item.proStatus}}</van-col>
                    </van-row>
                    <div class="proOther">
                      开始时间:{{child.startDate}}
                    </div>
                    <div class="proOther">
                      结束时间:{{child.endDate}}
                    </div>
                  </div>
                  <div v-else-if="ind%2!=0" class="childItem">
                    <div class="proName">{{child.name}}</div>
                    <van-row type="flex" justify="space-between" align="center">
                        <van-col class="proStatus">{{item.proStatus}}</van-col>
                    </van-row>
                    <div class="proOther">
                      开始时间:{{child.startDate}}
                    </div>
                    <div class="proOther">
                      结束时间:{{child.endDate}}
                    </div>
                  </div>
                </div>
              </div>
            </van-cell>
          </van-list>
        </div>
        <div v-else :style="{'width':clientWidth+'px','height':(clientHeight-200)+'px','display':'table-cell','vertical-align': 'middle','text-align':'center'}">
          <div>
            <div><img style="width:150px;" src="../../assets/noData.png"></div>
            <div>暂无项目</div>
          </div>
        </div>

        <!--
        <div style="width:100%;display: flex;flex-flow:row wrap;justify-content: space-between;">
          <div v-for="(item,i) in proList" :key="i" style="width:48%;" @click="toCompanyList(item.id,item.completeName)">
            <div v-if="i<4" class="proItem" style="margin-bottom:15px;">
              <div class="proName">{{item.completeName}}</div>
              <div class="proStatus">{{item.proStatus}}</div>
              <van-row class="proOther" type="flex" justify="space-between" align="center">
                  <van-col>{{item.startDate}} - {{item.endDate}}</van-col>
              </van-row>
            </div>
            <div v-else-if="i>3&&i<6" class="proItem">
              <div class="proName">{{item.completeName}}</div>
              <div class="proStatus">{{item.proStatus}}</div>
              <van-row class="proOther" type="flex" justify="space-between" align="center">
                  <van-col>{{item.startDate}} - {{item.endDate}}</van-col>
              </van-row>
            </div>
          </div>
        </div>-->

      </div>

      <van-tabbar v-model="active">
      <van-tabbar-item to="../homepage">
        <span>主页</span>
        <template #icon="props">
          <img :src="props.active ? icon.homeInActive : icon.homeActive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="../project/proList">
        <span>项目</span>
        <template #icon="props">
          <img :src="props.active ? icon.proInActive : icon.proActive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="../common/me">
        <span>我的</span>
        <template #icon="props">
          <img :src="props.active ? icon.meInActive : icon.meActive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
    </div>
</template>
<script>
    import $ from '@/fly'
    export default {
        name: 'project-proList',
        data () {
            return {
                icon: {
                    homeInActive: require('../../assets/inHomeIcon.svg'),
                    homeActive: require('../../assets/homeIcon.svg'),
                    proInActive: require('../../assets/inProIcon.svg'),
                    proActive: require('../../assets/proIcon.svg'),
                    meInActive: require('../../assets/inMeIcon.svg'),
                    meActive: require('../../assets/meIcon.svg')
                },
                active: 1,
                clientHeight: window.screen.height,
                clientWidth: window.screen.width,
                proList: [],
                pageNum: 1,
                pageSize: 5,
                loading: false,
                finished: false,
                proLength: 0
            }
        },
        computed: {
        },
        methods: {
            toCompanyList (id, name) {
                localStorage.setItem('projectName', name);
                localStorage.setItem('projectId', id);
                localStorage.setItem('toBackURL',this.$router.currentRoute.fullPath)
                this.$router.push({ name: 'project-companyList' });
            },
            onLoad () {
                this.pageNum = this.pageNum + 1;
                setTimeout(() => {
                    $.get('projectLeaderStatistics/processing-project', {
                        pageNum: this.pageNum,
                        pageSize: this.pageSize
                    }).then(res => {
                        res.rows.forEach(item => {
                            this.proList.push(item);
                        })
                        this.proList.forEach(item => {
                            if (new Date() < Date.parse(item.startDate)) {
                                item.proStatus = '项目未开始';
                            } else if (new Date() > Date.parse(item.startDate) && new Date() < Date.parse(item.endDate)) {
                                item.proStatus = '项目进行中';
                            } else if (new Date() > Date.parse(item.endDate)) {
                                item.proStatus = '项目已结束';
                            }
                            item.children.forEach(child => {
                                if (new Date() < Date.parse(child.startDate)) {
                                    child.proStatus = '项目未开始';
                                } else if (new Date() > Date.parse(child.startDate) && new Date() < Date.parse(child.endDate)) {
                                    child.proStatus = '项目进行中';
                                } else if (new Date() > Date.parse(child.endDate)) {
                                    child.proStatus = '项目已结束';
                                }
                            })
                        })
                        // 加载状态结束
                        this.loading = false;
                        // 数据全部加载完成
                        if (this.proList.length >= this.proLength) {
                            this.finished = true;
                        }
                    })
                }, 1000);
            }
        },
        mounted () {
            $.get('projectLeaderStatistics/processing-project', {
                pageNum: 1,
                pageSize: this.pageSize
            }).then(res => {
                this.proList = res.rows;
                this.proLength = res.total;
                this.proList.forEach(item => {
                    if (new Date() < Date.parse(item.startDate)) {
                        item.proStatus = '项目未开始';
                    } else if (new Date() > Date.parse(item.startDate) && new Date() < Date.parse(item.endDate)) {
                        item.proStatus = '项目进行中';
                    } else if (new Date() > Date.parse(item.endDate)) {
                        item.proStatus = '项目已结束';
                    }
                    item.children.forEach(child => {
                        if (new Date() < Date.parse(child.startDate)) {
                            child.proStatus = '项目未开始';
                        } else if (new Date() > Date.parse(child.startDate) && new Date() < Date.parse(child.endDate)) {
                            child.proStatus = '项目进行中';
                        } else if (new Date() > Date.parse(child.endDate)) {
                            child.proStatus = '项目已结束';
                        }
                    })
                })
                // 加载状态结束
                this.loading = false;
                // 数据全部加载完成
                if (this.proList.length >= this.proLength) {
                    this.finished = true;
                }
            })
            /**
            $.get('project/findThirdPartyManagerConsultantProject').then(res => {
                this.proList = res;
                this.proList.forEach(item => {
                    if (new Date() < Date.parse(item.startDate)) {
                        item.proStatus = '项目未开始';
                    } else if (new Date() > Date.parse(item.startDate) && new Date() < Date.parse(item.endDate)) {
                        item.proStatus = '项目进行中';
                    } else if (new Date() > Date.parse(item.endDate)) {
                        item.proStatus = '项目已结束';
                    }
                })
            }) */
        }
    }

</script>

<style lang="less" scoped>

    .proName{
      font-size: 28px;
      color: #464646;
      font-weight: 800;
      line-height: 55px;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
    }
    .proStatus{
      font-size: 18px;
      color: #1B75F6;
      font-weight: 800;
      line-height: 55px;
    }
    .proOther{
      line-height: 55px;
      color: #999999;
      font-size: 15px;
    }
    .proItem{
      background-color: #FFFFFF;
      padding: 15px 25px;
      font-size: 18px;
      width: 100%;
    }
    .teamHeardImg{
      width: 22px;
    }
    .parentPro{
      width:100%;
      background-color:#FFFFFF;
      margin-bottom:25px;
      padding:20px 20px 10px 20px;
    }
    .childItem{
      background-color: #F7F7F7;
      padding: 15px 25px;
      font-size: 18px;
      width: 100%;
      border-radius: 6px;
    }
    .parentProName{
      font-size: 28px;
      color: #464646;
      font-weight: 800;
      line-height: 55px;
      border-bottom:1px solid #F5F5F5;
      padding:5px 0px 10px 0px;
    }
</style>
